/* eslint-disable max-len */
import React from 'react';

var IconDelete = function IconDelete() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#444749",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10h1.5v9H9zM13.5 10H15v9h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.5h-11v11.357c0 .349.296.643.654.643h9.692a.655.655 0 0 0 .654-.643V8.5zM5 19.857V7h14v12.857C19 21.036 18.03 22 16.846 22H7.154A2.155 2.155 0 0 1 5 19.857zM16 3.996V4.5h-.63l-.44-.45.056-.055L16 3.996zM16 3v.996l.978.001.022.022 1.5-.01V5.5l-2.152-.003-.978-.996H8.621l-.987.988L4 5.484V4h3l.013-.013.987.001V3l.99.99 5.996.005L16 3zM9.06 4.06l-.439.44H8v-.512l.99.001.07.072zM5.5 4v1.484H4L4.001 4H5.5zm11.5.02L20 4v1.5L4 5.484V4h3l1-1h8l1 1.02z"
  }))));
};

export default IconDelete;